import React, { ComponentType } from 'react';
import { useBreakpoints } from '@ux/responsive';
import { ImagesWithAspectRatios } from 'core/ribbons/primitives';
import { ImageAspectRatio } from 'domain/constants/imageAspectRatio';
import withLanguage from 'presentation/hocs/withLanguage';
import createImageAlt from 'presentation/utils/createImageAlt';
import urlLanguageParse from 'presentation/utils/urlLanguageParse';
import getActiveImageWithAspectRatios from 'presentation/utils/getActiveImageWithAspectRatios';

import useStylesheet from './Image.stylesheet';

interface OuterProps {
  media: {
    imageUrl: string;
    imageAspectRatio?: ImageAspectRatio;
    imagesWithAspectRatios?: ImagesWithAspectRatios;
  };
}
interface InnerProps extends OuterProps {
  currentLanguage: string;
}
export const PureFilmstripImage = ({ media, currentLanguage }: InnerProps) => {
  const breakpoints = useBreakpoints();
  const activeImage = getActiveImageWithAspectRatios(
    breakpoints,
    {
      imageUrl: media.imageUrl,
      imageAspectRatio: media.imageAspectRatio,
    },
    media.imagesWithAspectRatios,
  );
  const { styles } = useStylesheet({ imageAspectRatio: activeImage.imageAspectRatio });
  const alt = createImageAlt({ imageUrl: activeImage.url });

  return (
    <div style={styles.outer}>
      <div style={styles.inner}>
        <img
          loading="lazy"
          src={urlLanguageParse(activeImage.url ?? '', currentLanguage)}
          alt={alt}
          style={styles.image}
        />
      </div>
    </div>
  );
};

PureFilmstripImage.displayName = 'FilmstripImage';

export default withLanguage(PureFilmstripImage) as ComponentType<OuterProps>;
